import { connect } from 'react-redux';
import Breadcrumbs from '../Components/Breadcrumbs/Breadcrumbs';
import RouteParser from '../Helpers/RouteParser';

const mapStateToProps = (state) => {
  const routeParser = RouteParser.create(
    state.router.location.pathname,
    state.router.location.query,
  );
  const breadcrumbs = [
    { step: 1, text: 'Event Type', active: false, disabled: true, link: null },
    {
      step: 2,
      text: 'Event Information',
      active: false,
      disabled: true,
      link: null,
    },
    {
      step: 3,
      text: 'Insured Information',
      active: false,
      disabled: true,
      link: null,
    },
    {
      step: 4,
      text: 'Policy Documents',
      active: false,
      disabled: true,
      link: null,
    },
  ];
  if (routeParser.isEventTypePage() || routeParser.isEventQuestionsPage()) {
    breadcrumbs[0].disabled = false;
    breadcrumbs[0].active = true;
  }
  if (
    routeParser.isEventQuestionsPage() ||
    routeParser.isApplicationPage() ||
    routeParser.isCheckoutPage()
  ) {
    breadcrumbs[0].disabled = false;
    breadcrumbs[0].link = routeParser.linkToEventTypePage();
  }
  if (routeParser.isApplicationPage()) {
    breadcrumbs[1].disabled = false;
    breadcrumbs[1].active = true;
  }
  if (routeParser.isCheckoutPage()) {
    breadcrumbs[2].disabled = false;
    breadcrumbs[2].active = true;
    breadcrumbs[1].disabled = false;
    breadcrumbs[1].link = routeParser.linkToApplicationPage();
  }
  if (routeParser.isThankyouPage()) {
    breadcrumbs.forEach((e, i) => {
      if (i === breadcrumbs.length - 1) {
        e.active = true;
      }
      e.disabled = false;
    });
  }
  return { breadcrumbs };
};

const BreadcrumbsContainer = connect(mapStateToProps)(Breadcrumbs);

export default BreadcrumbsContainer;
